__turbopack_context__.v({
  "organizerInfo": "OrganizerInfo-module-scss-module__9NEFYW__organizerInfo",
  "organizerName": "OrganizerInfo-module-scss-module__9NEFYW__organizerName",
});
